<div class="table-filter-section">
    <search-filter (searchChanged)="searchInputChange($event)"></search-filter>
    <service-filter
        class="autocomplete margin-left"
        (serviceSelectedChanged)="onServiceFilterChange($event)"
    ></service-filter>
    <medication-filter
        class="autocomplete margin-left"
        (medsSelectedChanged)="onMedicationFilterChange($event)"
        [services]="services"
    ></medication-filter>
    <button (click)="onClickSearch()" class="btn btn-success margin-left" type="button">
        Search
        <i class="icon-mag"></i>
    </button>
</div>
